import { Bell } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../ui/select';
import { DURATION_OPTIONS } from './constants';
import { formatDate, formatTime } from './utils';

/**
 * "Join Waitlist" dialog. Called when a slot is fully booked and the
 * customer wants to be notified if it frees up.
 */
export default function WaitlistModal({
  open, onOpenChange,
  selectedDate, waitlistForm, setWaitlistForm,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl flex items-center gap-2">
            <Bell className="h-5 w-5 text-amber-500" />
            Join Waitlist
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <p className="text-sm text-slate-600">
            You'll be notified by email if this slot becomes available due to a cancellation.
          </p>

          <div className="bg-slate-50 p-3 rounded-lg">
            <div className="grid grid-cols-2 gap-2 text-sm">
              <div>
                <span className="text-slate-500">Date:</span>
                <p className="font-medium">{formatDate(selectedDate)}</p>
              </div>
              <div>
                <span className="text-slate-500">Time:</span>
                <p className="font-medium">{formatTime(waitlistForm.preferred_start_time)}</p>
              </div>
            </div>
          </div>

          <div className="space-y-2">
            <Label>Preferred Duration</Label>
            <Select
              value={waitlistForm.duration}
              onValueChange={(value) => setWaitlistForm({ ...waitlistForm, duration: value })}
            >
              <SelectTrigger data-testid="waitlist-duration-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {DURATION_OPTIONS.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label>Notes (Optional)</Label>
            <Textarea
              value={waitlistForm.notes}
              onChange={(e) => setWaitlistForm({ ...waitlistForm, notes: e.target.value })}
              placeholder="Any specific requirements..."
              rows={2}
              data-testid="waitlist-notes-input"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            onClick={onConfirm}
            className="bg-amber-500 hover:bg-amber-600"
            data-testid="confirm-waitlist-btn"
          >
            Join Waitlist
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
